import { Customer } from "./customer";
import { Opportunity, OpportunityFile } from "./opportunity";

export enum OrderStatus {
  Kickoff = "KICKOFF",
  Developing = "DEVELOPING",
  Acceptance = "ACCEPTANCE",
  Handover = "HANDOVER",
  Collecting = "COLLECTING",
  Done = "DONE",
  Failed = "FAILED",
}

export enum OrderDebtStatus {
  Unpaid = "UNPAID",
  Paid = "PAID",
}

export enum OrderDebtFilter {
  Full = "FULL",
  None = "NONE",
  Partial = "PARTIAL",
}

export interface OrderDocument {
  id: number;
  label: string;
  files: OpportunityFile[];
}

export interface OrderDebt {
  id: number;
  content: string;
  percent: number;
  amount: number;
  preTaxAmount?: number;
  status: OrderDebtStatus;
  dueDate: string;
  collectedDate: string;
  partnerShare?: number; // phần đối tác của đợt thu (chỉ admin / sale phụ trách khách thấy)
}

export interface OrderDetail {
  id: number;
  description: string;
  unit: string;
  quantity: number;
  price: number;
  vatPercent: number;
  partnerDiscount?: number; // chiết khấu đối tác trên mỗi đơn vị
}

export interface Order {
  partnerName?: string; // chỉ admin / sale phụ trách khách được trả về
  canViewPartner?: boolean;
  id: number;
  createdAt: number;
  updatedAt: number;
  code: string;
  contractCode: string;
  status: OrderStatus;
  failReason: string;
  collectedAmount?: number;
  detailTotal?: number;
  detailTotalWithVat?: number;
  customer: Customer | null;
  opportunity: Opportunity | null;
  orderDocuments?: OrderDocument[];
  orderDebts?: OrderDebt[];
  orderDetails?: OrderDetail[];
}

export interface OrderCounts {
  all: number;
  statuses: Record<OrderStatus, number>;
}
